// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import '@styles/webdesktop/stylesheets/iconButton.scss';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { IconButtonTypeClass, IconButtonType } from './IconButtonTypes.interface';
import { StateStyle } from '../../Style';
export const IconButton = (_a) => {
    var { icon, type = IconButtonType.PanelTool, disabled = false, selected = false, className, onClick } = _a, restProps = __rest(_a, ["icon", "type", "disabled", "selected", "className", "onClick"]);
    const iconButtonClassNames = [
        'icon-button',
        className,
        IconButtonTypeClass[type],
        selected ? StateStyle.Selected : ''
    ];
    const iconButtonClassName = iconButtonClassNames.filter(Boolean).join(' ');
    return (React.createElement("button", Object.assign({ className: iconButtonClassName, onClick: onClick, disabled: disabled }, restProps),
        React.createElement(SvgIcon, { icon: icon })));
};
